// extracted by mini-css-extract-plugin
module.exports = {"viewer":"image-viewer_viewer__2iPjP","icon":"image-viewer_icon__1Tg7x","image":"image-viewer_image__2-tYB"};